import {
    AdjustCol,
    CheckboxCol,
    DistanceCol,
    NumberCol,
    RenderStringCol,
    Table,
    ViewOnly
} from "../../../../misc/scroller/Table";
import {api} from "../../../../api/API";
import {useAlternative} from "../alternative/Alternative";
import {useProjectId, useProjectUnitSystem} from "../../shopdrawing/ProjectName";
import {ScreenElevation} from "../../../../api/Openings";
import {useIsQuote} from "../QuoteContainer";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import {Grid, IconButton} from "@mui/material";
import {TextEditCell} from "./TextEditCell";
import {ScreenElevationPopup} from "./ScreenElevationPopup";
import React from "react";
import {getAll} from "../../../logistics/routes/useGetAll";
import {ext} from "../../../../api/Files";

export function ReviewScreenElevationTitle(props: {
    onDone(): void;
}) {
    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item>
                <IconButton onClick={props.onDone}>
                    <ChevronLeft />
                </IconButton>
            </Grid>
            <Grid item>
                Review Screen Elevations
            </Grid>
        </Grid>
    )
}

export function ReviewScreenElevations() {
    const alt = useAlternative();
    const project = useProjectId();
    const isQuote = useIsQuote();
    const sys = useProjectUnitSystem()

    if(!sys) return null;

    return (
        <Table<ScreenElevation>
            name={"screen-elevations"}
            fetch={ctx => {
                return getAll(ctx, offset => isQuote ?
                    api.quoteOpenings.listScreenElevations({
                        project: project,
                        alternative: alt,
                        offset,
                    }) :
                    api.openings.listScreenElevations({
                        project: project,
                        offset,
                    })
                )
            }}
            fetchDeps={[project, alt, isQuote]}
            columns={[
                AdjustCol(RenderStringCol<ScreenElevation>("Screen Elevation", data => data.screenElevation?.toString() || ""), {
                    editable: {
                        type: "custom",
                        copy: data => data.screenElevation?.toString() || "",
                        paste: (data, value) => {
                            data.screenElevation = value;
                        },
                        render: (props) => {
                            if(!props.row.screenElevation) {
                                return (
                                    <TextEditCell keyName="screenElevation" {...props} />
                                )
                            }

                            return <ScreenElevationPopup {...props} />
                        },
                        fileDropAccept: ["application/pdf", "image/*"],
                        fileDropAction: async (files, info) => {
                            const fileObj = await api.files.upload({
                                file: files[0],
                                // use guid naming to prevent collisions
                                name: window.crypto.randomUUID() + ext(files[0].name),
                                convert2pdf: true,
                            });

                            info.update(Object.assign({}, info.row, {
                                screenElevationFile: fileObj.id,
                            }));
                        },
                    },
                    editObj: (dst, src, value: string) => {
                        dst.screenElevation = value;
                        dst.screenElevationFile = undefined;
                    },
                }),
                RenderStringCol<ScreenElevation>("Has Attachment", data => data.screenElevationFile ? "Yes" : "No", 100),
                DistanceCol("Outside Height", sys, "screenElevationOutsideHeight"),
                DistanceCol("Outside Width", sys, "screenElevationOutsideWidth"),
                CheckboxCol("Fixed Mullion", "hasFixedMullion"),
                ViewOnly(NumberCol("Qty", "count"))
            ]}
            onChange={v => {
                if(isQuote) return api.quoteOpenings.updateScreenElevation(v)
                return api.openings.updateScreenElevation(v)
            }}
        />
    )
}